import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import {
  mergeDuplicateUsers,
  MergeGroup,
} from "@/features/users/services/merge-duplicate-users";

export function useMergeDuplicateAccounts() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (groups: MergeGroup[]) => mergeDuplicateUsers(groups),
    onSuccess: (data) => {
      toast({
        title: "Merge complete",
        description: `${data.merged} group${data.merged !== 1 ? "s" : ""} merged successfully.`,
      });
      queryClient.invalidateQueries({ queryKey: ["duplicate-accounts"] });
    },
    onError: () => {
      toast({
        title: "Merge failed",
        description: "Something went wrong. Please try again.",
        variant: "destructive",
      });
    },
  });
}
